import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { toast } from "react-toastify";
import { machineProfile } from "../../api/index.js";
import { toPng } from "html-to-image";
import { jsPDF } from "jspdf";
import LoadingIndicator from "../../components/LoadingIndicator/index.jsx";
import { renderImage, printLocation } from "../../utils/helper.jsx";
import { format, isAfter } from "date-fns";
import { MachineHealth } from "../../components/MachineHealth/index.jsx";
import { MachineHistory } from "../../components/MachineHistory/index.jsx";
import MachineImpactHistory from "../../components/MachineImpactHistory/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import { MachineElements } from "./components/MachineElements";

const printDate = (date) => {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    // it is a date
    if (isNaN(date)) {
      // d.getTime() or d.valueOf() will also work
      return "-";
    } else {
      // date object is valid
    }
  } else {
    return "-";
  }
  if (!date) return "-";
  const dateSplit = date.split("-");
  const day = dateSplit[0] ? dateSplit[0] : "";
  const month = dateSplit[1]
    ? format(new Date().setMonth(dateSplit[1] - 1), "MMMM")
    : "";
  const year = dateSplit[2] ? dateSplit[2] : "";
  return day + " " + month + " " + year;
};

function PageMachineProfile() {
  const { machineId } = useParams();
  const { hash } = useLocation();
  const { config, isHiddenFeature, getLocationName, email } = useAuth();
  const roleItem = config?.RoleCompanyMaster[0]?.feature_access;
  const woExist = roleItem?.find((item) => item === "Work Order Overview");
  const [openModal, setOpenModal] = React.useState(false);
  const defaultMenu = hash
    ? hash.replace("#", "")
    : !isHiddenFeature("machine_health")
    ? "machinehealth"
    : "sensor";
  const [selectedMachine, setSelectedMachine] = useState();
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [origin, setOrigin] = useState("");
  const location = useLocation();
  const [documents, setDocuments] = useState([]);
  const [docName, setDocName] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [subNavMenus, setSubNavMenus] = useState([]);
  const [activeMenu, setActiveMenu] = useState(defaultMenu);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);

  const [locations, setLocations] = useState([]);
  const getMachine = async () => {
    try {
      setLoading(true);
      const res = await machineProfile.getOne(machineId);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setSelectedMachine(data);

        if (data.scheduled_maintenances) {
          setSchedules(data.WorkOrder);
        } else {
          setSchedules([]);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    //console.log("fetching wave");
    getMachine(machineId);
  }, [machineId]);

  useEffect(() => {
    if (selectedMachine) {
      const locationName = [];
      function generateLocation(location) {
        locationName.push(location.location_name);
        if (location.parent_location) {
          generateLocation(location.parent_location);
        }
      }

      generateLocation(selectedMachine.location);
      setLocations(locationName.reverse());
    }
  }, [selectedMachine]);
  function isActive(item) {
    return item === activeMenu;
  }
  useEffect(() => {
    let check = window.location;
    setOrigin(check.origin);
    let tabs = [];

    if (!isHiddenFeature("machine_health")) {
      tabs.push({ uid: "machinehealth", name: "Machine Health" });
    }

    tabs.push({ uid: "sensor", name: "Live Sensor Data" });
    if (woExist) {
      tabs.push({ uid: "calendar", name: "Work Order Schedule" });
    }
    tabs.push({ uid: "history", name: "History" });
    tabs.push({ uid: "impact", name: "Success & Impact" });
    tabs.push({ uid: "info", name: "Info" });

    setSubNavMenus(tabs);
  }, []);

  useEffect(() => {
    if (!selectedFile) {
      setPicture(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPicture(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const downloadPDF = () => {
    toPng(document.getElementById("profile-full"), { quality: 0.95 }).then(
      function (dataUrl) {
        var link = document.createElement("a");
        link.download = "my-image-name.jpeg";
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(dataUrl);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("download.pdf");
      }
    );
  };

  const getMachineElementName = (d) => {
    const words = d.machine_element_name?.trim().split(" ");
    const lastWord = words[words.length - 1];

    if (lastWord !== 'DE' || lastWord !== 'NDE') {
      const date = new Date("2025-08-19")
      if (isAfter(new Date(d.date), date)) {
        if (d.machine_element_position === 'drive_end') {
          return d.machine_element_name + " DE"
        }
        if (d.machine_element_position === 'non_drive_end') {
          return d.machine_element_name + " NDE"
        }
      }
    }
    return d.machine_element_name
  }

  const clickMenu = (menu) => {
    setActiveMenu(menu);
    navigate(`#${menu}`);
  };

  const getSensors = () => {
    const sensors = [];
    if (selectedMachine && selectedMachine.machine_elements) {
      selectedMachine.machine_elements.map((me) => {
        if (me.deployments) {
          me.deployments.map((d) => {
            let sensor = d.sensor;
            sensor.machine_element_name = me.machine_element_name;
            sensor.machine_element_id = me.id;
            sensor.machine_element_position = d.machine_element_position;
            sensor.date = d.deployed_on;
            sensor.deployments_id = d.id;
            sensors.push(sensor);
          });
        }
      });
    }

    return sensors;
  };

  return (
    <div>
      <LoadingIndicator open={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">MACHINE</li>
            <li className="breadcrumb-item active">MACHINE PROFILE</li>
          </ol>
          <h1 className="page-header mb-0">Machine Profile</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-4">
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Machine Information
            </CardHeader>
            <CardBody>
              <div className="row">
                <div className="col-lg-12 col-sm-12 mb-2">
                  <Card>
                    <CardBody style={{ padding: "7px" }}>
                      <ImageViewer
                        src={selectedMachine?.attachments?.filePhoto}
                      />
                    </CardBody>
                    <CardFooter className="text-theme fw-bold text-center">
                      {selectedMachine?.machine_name}
                    </CardFooter>
                  </Card>
                </div>
                <div className="col-lg-12 col-sm-12">
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Machine Type</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedMachine?.machine_type?.name}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Brand</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedMachine?.machine_brand?.trim() || "-"}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Date of Purchase</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {printDate(selectedMachine?.purchase_date)}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Warranty Until</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {printDate(selectedMachine?.warranty_date)}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>ISO Standard</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedMachine?.iso_standard || "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Machine Location
            </CardHeader>
            {email === "demokit2@groundup.ai" ? (
              <CardBody className="card-body pb-2">
                <div>
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div> Plant</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        Groundup Facility
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                </div>
              </CardBody>
            ) : (
              <CardBody className="card-body pb-2">
                {locations.map((l, index) => {
                  return (
                    <div key={index}>
                      <div className="d-flex">
                        <div className="flex-1 d-flex">
                          <div> {getLocationName(index)}</div>
                          <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                            {printLocation(l)}
                          </span>
                        </div>
                      </div>
                      <hr style={{ margin: "0.3rem 0" }} />
                    </div>
                  );
                })}
              </CardBody>
            )}
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Machine Operation
            </CardHeader>
            <CardBody className="card-body pb-2">
              <div className="d-flex">
                <div className="flex-1 d-flex">
                  <div>Operating Hour</div>
                  <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                    {selectedMachine
                      ? selectedMachine.start_operating_hour
                      : ""}{" "}
                    -{" "}
                    {selectedMachine ? selectedMachine.end_operating_hour : ""}
                  </span>
                </div>
              </div>
              <hr style={{ margin: "0.3rem 0" }} />
              <div className="d-flex">
                <div>
                  <div>Sensor Added</div>
                  <ul>
                    {getSensors().map((s, index) => (
                      <li key={index}>
                        {s.sensor_serial_number} - {getMachineElementName(s)}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-8">
          <Card className="mb-4">
            <CardBody>
              <ul className="nav nav-tabs">
                {!isHiddenFeature("machine_health") && (
                  <li className="nav-item me-1">
                    <a
                      href="#home"
                      className="nav-link active"
                      data-bs-toggle="tab"
                    >
                      Machine Health
                    </a>
                  </li>
                )}
                <li className="nav-item me-1">
                  <a
                    href="#profile"
                    className={`nav-link ${
                      isHiddenFeature("machine_health") ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                  >
                    History
                  </a>
                </li>
                <li className="nav-item me-1">
                  <a
                    href="#elements"
                    className={`nav-link ${
                      isHiddenFeature("machine_health") ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                  >
                    Machine Elements
                  </a>
                </li>

                {/*<li className="nav-item me-1">*/}
                {/*  <a*/}
                {/*    href="#workOrder"*/}
                {/*    className="nav-link"*/}
                {/*    data-bs-toggle="tab"*/}
                {/*  >*/}
                {/*    Work Order*/}
                {/*  </a>*/}
                {/*</li>*/}
                <li className="nav-item me-1">
                  <a href="#success" className="nav-link" data-bs-toggle="tab">
                    Success & Impact
                  </a>
                </li>
                {/*<li className="nav-item me-1">*/}
                {/*  <a href="#wo" className="nav-link" data-bs-toggle="tab">*/}
                {/*    Work Order Schedule*/}
                {/*  </a>*/}
                {/*</li>*/}
              </ul>
              <div className="tab-content pt-3">
                {!isHiddenFeature("machine_health") && (
                  <div className="tab-pane fade show active" id="home">
                    {selectedMachine && (
                      <MachineHealth machine={selectedMachine} />
                    )}
                  </div>
                )}
                <div
                  className={`tab-pane fade ${
                    isHiddenFeature("machine_health") ? "show active" : ""
                  }`}
                  id="profile"
                >
                  {selectedMachine && (
                    <MachineHistory machine={selectedMachine} />
                  )}
                </div>
                <div
                  className={`tab-pane fade ${
                    isHiddenFeature("machine_health") ? "show active" : ""
                  }`}
                  id="elements"
                >
                  {selectedMachine && (
                    <MachineElements machine={selectedMachine} submited={getMachine} />
                  )}
                </div>
                <div className="tab-pane fade" id="workOrder">
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>Work Order</div>
                    <button className=" btn btn-outline-theme">
                      <i className="fa fa-user-cog"></i> Create work Order{" "}
                    </button>
                  </div>
                  <div className="table-responsive mt-2">
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          <th>Work Order No</th>
                          <th>Title</th>
                          <th>Start Date</th>
                          <th>Due Date</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
                <div className="tab-pane fade" id="success">
                  {selectedMachine && (
                    <MachineImpactHistory machine={selectedMachine} />
                  )}
                </div>
                <div className="tab-pane fade" id="wo">
                  {/* <FullCalendar plugins={plugins}></FullCalendar> */}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default PageMachineProfile;
